// eslint-disable-next-line
export const cloneAnything = <T extends any>(anything: T): T => {
  if (!anything) {
    return anything;
  }
  try {
    return JSON.parse(JSON.stringify(anything));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    console.warn('Could not properly deep clone object');
    return anything;
  }
};
